import { useQuery } from '@tanstack/react-query'
import { getOutstandingActions } from '../../services/outstanding-actions/outstanding-actions-service'
import { isKnownOutstandingActionKey } from '../types/outstanding-actions.types'

export const outstandingActionsKey = ['outstanding-actions'] as const

/**
 * Backs the header badge, so unlike the rest of the app it polls: the whole point is noticing work
 * that arrived while you were on another page. This is a deliberate, contained exception to the
 * manual-refresh-only defaults in main.tsx — one cheap count query, not a change of policy.
 */
export const useOutstandingActions = () => {
  return useQuery({
    queryKey: outstandingActionsKey,
    queryFn: getOutstandingActions,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
    select: (data) => ({
      ...data,
      // A category the API knows about but this build does not has no label, icon or route here, so
      // it is dropped rather than rendered as a blank row. It still counts toward totalCount, which
      // is the server's number and stays authoritative.
      actions: data.actions.filter((action) => isKnownOutstandingActionKey(action.key)),
    }),
  })
}
